// src/utils/tz.js
import { formatInTimeZone } from 'date-fns-tz';

/**
 * Formate une date UTC en heure locale Montréal (America/Toronto)
 * @param {string|Date} dateTime - ex: "2025-08-28T15:00:00Z" ou un Date()
 * @param {string} pattern - ex: "yyyy-MM-dd HH:mm:ss"
 * @returns {string}
 */
export function formatInMontreal(dateTime, pattern = "yyyy-MM-dd HH:mm:ss") {
  if (!dateTime) return "";
  try {
    return formatInTimeZone(dateTime, "America/Toronto", pattern, { locale: undefined });
  } catch (e) {
    console.error("❌ Erreur formatInMontreal:", e, dateTime);
    return String(dateTime);
  }
}

/**
 * Récupère la date et heure prêtes à afficher pour l’utilisateur
 * Exemple : { date: "28 août 2025", time: "11:00" }
 */
export function formatDateTimeForUI(dateTime) {
  if (!dateTime) return { date: "", time: "" };

  const date = formatInTimeZone(dateTime, "America/Toronto", "dd/MM/yyyy");
  const time = formatInTimeZone(dateTime, "America/Toronto", "HH:mm");

  return { date, time };
}
